<template>
	<div class="animated fadeIn">
		<div class="row pageinfo">
      <b-col lg="6">
        <!--Display Trash or Normal Table View-->
        <h2>API - Keys</h2>
			</b-col>
    </div>
		<div class="card">
		    <div class="card-body">
			    <b-row>
		        	<b-container fluid roles>
								<div class="row">

									<b-col lg="6" md="6" xs="12" class="my-1">
										<div class="input-group mb-3">
											<div class="input-group-prepend">
												<b-form-input v-model="filter" placeholder="Search" />
												<b-btn class="brad-0" :disabled="!filter" @click="filter = ''">Clear</b-btn>
											</div>
										</div>
									</b-col>

									<b-col lg="6" md="6" xs="12">
										<b-button @click="showNewLocationModal" variant="primary" class="active mb-3 pull-right">Assign Key</b-button>
									</b-col>
								</div>
		        			<b-row v-if="loadingData">
			              <b-col cols="12" sm="12" md="12" lg="12">
			                 <p class="text-center">
			                   <i class="fa fa-refresh fa-lg mt-4 fa-spin"></i><br>Loading data...
			                 </p>
			              </b-col>
			            </b-row>
									<b-table 	class="animated fadeIn" striped hover v-else bordered show-empty
													stacked="md"
													:items="items"
													:fields="fields"
													:current-page="currentPage"
													:per-page="perPage"
													:filter="filter"
													:sort-by.sync="sortBy"
													:sort-desc.sync="sortDesc"
													@filtered="onFiltered"
												>
												<template slot="actions" slot-scope="row">


													<!-- We use @click.stop here to prevent a 'row-clicked' event from also happening 
														<b-button size="sm" class="mr-1" onclick="location.href = 'http://dev.drifttech.io:8081/apidocs/#/';" >
															Test
														</b-button> -->
													<!-- We use @click.stop here to prevent a 'row-clicked' event from also happening 
														<b-button  @click.stop="copyKey(row)"size="sm" class="mr-1" type="button"
															v-clipboard:copy="row.item.key"
															v-clipboard:success="onCopy"
															v-clipboard:error="onError">Copy to clipboard
														</b-button> -->
													<b-button size="sm" @click.stop="renewKey(row)" class="mr-1">
														Renew
													</b-button>
													<b-button size="sm" @click.stop="deleteKey(row)">
														Delete
													</b-button>
												</template>
            			</b-table>
									<b-row>
										<b-col lg="2" md="2" sm="12" class="my-1 pull-left">
											<div class="input-group mb-3">
												<div class="input-group-prepend"> </div>
												<b-select :options="pageOptions" v-model="perPage" />
											</div>
										</b-col>
										<b-col lg="10" md="10" sm="12" class="my-1 pull-right">
											<b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0 pull-right" />
										</b-col>
									</b-row>
					</b-container>
				</b-row>
		    </div>
		</div>
		    <!-- New EModal-->
    <b-modal title="New Role" ref="newLocationModal" v-model="newLocations" hide-header-close no-close-on-backdrop no-close-on-esc>
      <b-row>
				<b-col cols="12">
          <b-form-group :label-cols="4" horizontal label="Company Type" label-for="api0">
				    <b-form-select id="api0" value-field="id" text-field="name" v-model="model.company_type_id" :options="company_type" @input="select_company_type()"/>
			    </b-form-group>
        </b-col> 
       <!-- <b-col cols="12">
				 <b-form-group :label-cols="4" id="L4" label="Energy Companies" label-for="EnergyCompanyID" horizontal>
					 <b-form-select id="EnergyCompanyID" v-model="energy_company_id" :options="energy_companies"/>
				 </b-form-group>
        </b-col>-->
				<b-col cols="12">
            <b-form-group v-if ="model.company_type_id === 0" :label-cols="4" horizontal label="Energy Companies" label-for="api1">
				      <b-form-select id="api1" value-field="id" text-field="name" v-model="model.company_id" :options="company_name" @input="select_company()"/>
			      </b-form-group>
            <b-form-group v-else :label-cols="4" horizontal label="Trucking Companies" label-for="api1">
				      <b-form-select id="api1" value-field="id" text-field="name" v-model="model.company_id" :options="company_name" @input="select_company()"/>
			      </b-form-group>
        </b-col> 
      </b-row>

			<div slot="modal-footer" class="w-100">
        <b-btn size="md" variant="secondary" @click="hideNewLocationModal" class="float-left">Cancel</b-btn>
        <b-btn :disabled="savebtn" size="md" variant="primary" @click="assignKey" class="float-right">Save</b-btn>
      </div>
    </b-modal>
	</div>
</template>

<script>

	import Vue from 'vue'
	import keys_service from './keys_service'

	const items = []
	const energy_companies = []
	export default {
		name: 'keys',
		created: function () {
				this.getAll()

	    },
		data () {
			return {
				newLocations: false,
				items: items,
				energy_companies:energy_companies,
				loadingData: true,
				currentPage: parseInt(localStorage.rolesPage),
		    perPage: 25,
		    totalRows: items.length,
		    pageOptions: [ 25, 50, 100],
		    sortBy: null,
		    sortDesc: false,
		    fields: [
					{ key: 'id', label: 'Id', sortable: true },
					{ key: 'key', label: 'Key', sortable: true},
					{ key: 'company_type', label: 'Company Type', sortable: true},
					{ key: 'company_name', label: 'Company Name', sortable: true},
					{ key: 'created_by_user', label: 'Created By', sortable: true},
					{ key: 'created_at', label: 'Created At', sortable: true},
					{ key: 'updated_at', label: 'Updated At', sortable: true},
					{ key: 'actions', label: 'Actions', sortable: false},
		    ],
		    filter: null,
		    modalInfo: { title: '', content: '' },
		    configTable: false,
				model:{
						company_id			: 0,
						company_name 	  : '',
						company_type_id : 0,
				},
				savebtn:true,
				energy_company_id: null,
				company_type    : [],
				company_name    : [],
				role            : '',
		}
	},
		computed: {
	      sortOptions () {
	        // Create an options list from our fields
	        return this.fieldsTh
	          .filter(f => f.sortable)
	          .map(f => { return { text: f.label, value: f.key } })
	      }
			},
	    methods: {
			copyKey(row){
				this.$swal('Copied!', 'You just copied: ' + row.item.key, 'success')
			},
	    	onFiltered (filteredItems) {
					this.currentPage = parseInt(localStorage.rolesPage)
		    	this.totalRows = filteredItems.length
		    	this.currentPage = 1
		    },
		    resetModal () {
		        this.modalInfo.title = ''
		        this.modalInfo.content = ''
				},
				hideNewLocationModal() {
					this.$refs.newLocationModal.hide()
				},
				showNewLocationModal() {
					this.model={
						company_id			: 0,
						company_name 	  : '',
						company_type_id : 0,
					}
					this.savebtn=false
					this.newLocations = true
				},
				renewKey(row) {
						keys_service.renewKey(row.item.id)
            	.then(data => {
              	this.$swal(data[0], data[1], data[0])
              	if (data[0] == 'success') {
                	this.newLocations = false
                	this.model = {}
                	this.getAll()
              	}
            	})
            	.catch(error => {
              	this.$swal('Error', 'Server not response. ' + error, 'error')
            	})
					this.savebtn=false
				},
				deleteKey(row) {
					this.$swal({
						title: 'Please, confirm',
						text: "Are you sure to delete this Key?",
						type: 'question',
						showCancelButton: true,
						confirmButtonColor: '#3085d6',
						cancelButtonColor: '#d33',
						confirmButtonText: 'Yes',
						reverseButtons: true
					}).then((result) => {
						if (result.value) {
							keys_service.deleteKey(row.item.id)
								.then(data => {
									this.$swal(data[0], data[1], data[0])
									if (data[0] == 'success') {
										this.newLocations = false
	                	this.model = {}
	                	this.getAll()
									}
								})
								.catch(error => {
									this.$swal('Error', 'Server not response. ' + error, 'error')
								})
						}
					})
					this.edit = false
				},
      	assignKey () {
					this.savebtn=true
					console.log(this.model)
        	if (this.model != null ) {
						keys_service.save(this.model)
            	.then(data => {
              	this.$swal(data[0], data[1], data[0])
              	if (data[0] == 'success') {
                	this.newLocations = false
                	//this.model = {}
                	this.getAll()
              	}
            	})
            	.catch(error => {
              	this.$swal('Error', 'Server not response. ' + error, 'error')
            	})
        	} else {
							this.$swal('Alert!', 'Data Required', 'warning')
        	}
					this.savebtn=false
      	},
      getAll () {
        this.loadingData = true
        keys_service.getAll()
          .then(data => {
                if (data.status == 'success') {
									this.items = data.keys
									// this.energy_companies = data.insert_data.energy_companies
									//this.energy_companies = data.insert_data.energy_companies.map((item) => {
									//	return {
									//		'value': item.id,
									//		'text': item.company_name
									//	}
									// })
									this.company_type         = data.insert_data.companies
									//this.energy_companies     = data.insert_data.companies[0].energy_companies
									this.company_name  				=  this.company_type[0].energy_companies
									this.role 								= data.role
                } else {
                  this.items = []
                  this.$swal(data[0], data[1], data[0])
                }
                this.loadingData = false
          })
          .catch(error => {
            this.$swal('Error', 'Server not response. ' + error, 'error')
            this.loadingData = false
          })
			},
			select_company_type() {
        if (this.role =='super_admin') {         
            if (this.model.company_type_id === 0) {
                this.company_name  =  this.company_type[0].energy_companies  
                this.model.company_id  = null
            } else {
                this.company_name  =  this.company_type[1].trucking_companies
                this.model.company_id  = null
            }	 
        }
			},
			select_company() {
        if (this.role =='super_admin') {        
            let companies = this.company_name
			let company_index = companies.map(o => o.id).indexOf(this.model.company_id)
			if (company_index > -1) {
			    this.model.company_name = companies[company_index].name
			} else {
                this.model.company_name = ''
			}
        }
    	},
	    }
	}
</script>



// WEBPACK FOOTER //
// src/views/keys/keys.vue